// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../configs/app-info';

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Autocomplete,
    Fab
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import MsiDatagridGroup from '../../../components/custom/MsiDatagridGroup';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import { getDoctag } from '../../../api/helper';

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    // ** State
    const [tabs, setTabs] = useState<string>("0")

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))
    const [doctag, setDoctag] = useState<any>(null)
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [listData, setListData] = useState<any[]>([])

    useEffect(() => {
        getData(tabs)
        const fetchDoctag = async () => {
            let data = [{ id: null, nama: '-- Semua Document --' }];
            const response = await getDoctag(appInfo.menuId.usage, cabang, token);
            data = data.concat(response);
            setListDoctag(data);
            setDoctag(null);
            setValDoctag('-- Semua Document --');
        };
        fetchDoctag();
    }, [])

    const navigate = useNavigate();

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setDoctag(newValue ? newValue.id : null);
        setValDoctag(newValue ? newValue.nama : '');
    }

    const getData = (mode: any) => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/mm/usage/list'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    sysdoctag_id: doctag,
                    mode: mode,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/mm/usage/delete/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData(tabs)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    const ActionButtons = ({ row, onDelete, onNavigate, onPrint }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void;
        onPrint: (id: string) => void;
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Print",
                icon: "mdi:file-pdf",
                color: "red",
                onClick: () => onPrint(row.id)
            },
            {
                title: "Hapus Usage",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row)
            }
        ];

        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 140,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => navigate('/mm/usage/detail/' + id)}
                    onPrint={(id) => window.open(apiUrl.baseUrl + '/mm/usage/preview/' + id, '_blank')}
                />
            ),
        },
    ];

    const convertComponent = [
        {
            key: 'nama_barang',
            renderCell: ({ row }: any) => (
                <div
                    style={{
                        maxWidth: 300,
                        whiteSpace: 'normal',     // allow wrap
                        wordBreak: 'break-word', // pecah kata panjang
                        lineHeight: '1.4'
                    }}
                >
                    {row.data.nama_barang}
                </div>
            )
        }
    ]
    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='USAGE' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab color='primary' size='medium' onClick={() => navigate('/mm/usage/add')}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='doctag'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDoctag}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='Document'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>

                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData(tabs)}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='Daftar Usage' />
                            <Tab value='1' label='Usage Belum Aktif' />
                            <Tab value='2' label='Outstanding Preview' />
                            <Tab value='3' label='MRP' />
                        </TabList>
                        <TabPanel value='0'>
                            <MsiDatagrid array={listData} actions={actionData} />
                        </TabPanel>
                        <TabPanel value='1'>
                            <MsiDatagrid array={listData} actions={actionData} />
                        </TabPanel>
                        <TabPanel value='2'>
                            <MsiDatagridGroup array={listData} groupBy={['preview']} hiddenColumns={['barang_id', 'is_buy']} rowStyleRules={[
                                { field: 'is_buy', operator: '==', value: 0, color: '#ffffff' },
                                { field: 'is_buy', operator: '==', value: 1, color: '#FFF59D' },
                            ]} />
                        </TabPanel>
                        <TabPanel value='3'>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    mb: 2
                                }}
                            >
                                <Button
                                    variant='contained'
                                    color='secondary'
                                    sx={{ mr: 3 }}
                                    startIcon={<Icon icon='mdi:plus' />}
                                    onClick={() => {
                                        Swal.fire({
                                            title: 'Konfirmasi',
                                            text: 'Apakah anda ingin membuat Purchase Request dari data MRP ini?',
                                            icon: 'question',
                                            showCancelButton: true,
                                            confirmButtonColor: '#9c27b0',
                                            cancelButtonColor: '#ffc107',
                                            confirmButtonText: 'Buat PR'
                                        }).then(result => {
                                            if (result.isConfirmed) {
                                                Swal.fire({
                                                    title: 'Now loading',
                                                    allowEscapeKey: false,
                                                    allowOutsideClick: false,
                                                    didOpen: () => Swal.showLoading()
                                                })

                                                const url = `${apiUrl.apiUrl}/mm/usage/create-pr-mrp`

                                                axios
                                                    .post(url, {}, {
                                                        headers: {
                                                            Authorization: `Bearer ${token}`,
                                                        },
                                                    })
                                                    .then(response => {
                                                        if (response.data.success) {
                                                            Swal.fire({
                                                                title: 'Berhasil',
                                                                text: response.data.message,
                                                                icon: 'success',
                                                                timer: 1200,
                                                                timerProgressBar: true,
                                                                willClose: () => navigate('/purchasing/purchase-request/detail/' + response.data.data)
                                                            })
                                                        } else {
                                                            Swal.fire({
                                                                title: 'Gagal',
                                                                text: response.data.message,
                                                                icon: 'error'
                                                            })
                                                        }
                                                    })
                                                    .catch(error => {
                                                        Swal.fire({
                                                            title: 'Error',
                                                            text: error.message,
                                                            icon: 'error'
                                                        })
                                                    })
                                            }
                                        })
                                    }
                                    }
                                >
                                    Buat Purchase Request
                                </Button>
                                <Button
                                    variant='contained'
                                    startIcon={<Icon icon='mdi:magnify' />}
                                    onClick={() => getData("3")}
                                >
                                    Refresh Data
                                </Button>
                            </Box>

                            {/* Datagrid */}
                            <MsiDatagrid array={listData} customRender={convertComponent} hiddenColumns={['is_kain']} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
        </Grid>
    )
}
